"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MediumFromBrowserAdapter = (function () {
    function MediumFromBrowserAdapter(mediumForBrowser) {
        if (mediumForBrowser.children) {
            this.mediumGroups = mediumForBrowser.children;
            this.groupTitle = mediumForBrowser.longTitle;
        }
        else {
            this.mediumGroups = [MediumFromBrowserAdapter.convertBrowserMediumToMedium(mediumForBrowser)];
            this.groupTitle = "";
        }
    }
    MediumFromBrowserAdapter.convertBrowserMediumToMedium = function (browserMedium) {
        return {
            longTitle: browserMedium.longTitle,
            shortTitle: browserMedium.shortTitle,
            type: browserMedium.type,
            key: browserMedium.key,
            tag: browserMedium.tag
        };
    };
    return MediumFromBrowserAdapter;
}());
exports.MediumFromBrowserAdapter = MediumFromBrowserAdapter;
//# sourceMappingURL=mediumFromBrowserAdapter.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/adapters/mediumFromBrowserAdapter.js
// module id = 2
// module chunks = 0